import { render, staticRenderFns } from "./SimpleJobView.vue?vue&type=template&id=0d5f4ef2&scoped=true&"
import script from "./SimpleJobView.vue?vue&type=script&lang=js&"
export * from "./SimpleJobView.vue?vue&type=script&lang=js&"
import style0 from "./SimpleJobView.vue?vue&type=style&index=0&id=0d5f4ef2&prod&scoped=true&lang=css&"
import style1 from "./SimpleJobView.vue?vue&type=style&index=1&id=0d5f4ef2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f4ef2",
  null
  
)

export default component.exports